import { wrapLazily } from "../lazy-loading/lazyWrapper";
export const routes = () => {
	const routePv = {
		path: "/pv",
		component: wrapLazily(() => import("sd_pdp_ui/ArticleFetcher"), {
			usesBootstrap: true,
			usesMoment: true,
		}),
		routeParam: {
			trackingName: "productpage",
			noCustomerNeed: false,
		},
		childRoutes: [
			{
				path: ":articleId",
				childRoutes: [
					{
						path: ":variantId",
						childRoutes: [
							{
								path: ":bundleId",
								routeParam: {
									visibleForAnonymous: true,
								},
							},
							{
								path: ":bundleId/*",
								routeParam: {
									visibleForAnonymous: true,
								},
							},
						],
					},
				],
			},
		],
	};
	const routeEpv = {
		path: "/epv",
		component: wrapLazily(() => import("sd_pdp_ui/ArticleFetcher"), {
			usesBootstrap: true,
			usesMoment: true,
		}),
		routeParam: {
			trackingName: "employeeProductView",
			noCustomerNeed: true,
			productViewType: "employee",
		},
		childRoutes: [
			{
				path: ":articleId/:variantId/:bundleId",
				routeParam: {},
			},
		],
	};
	return [routePv, routeEpv];
};
